export default "__VITE_ASSET__CezdqD8o__"